import {Navigate, useParams} from 'react-router-dom';

import {getSharePanelSearch} from '@/features/trust-accounts/share';

import type {FC} from 'react';

/** `/trust-accounts/:id/team` links predate the share panel; they open the account with it on people. */
export const LegacyTeamRedirect: FC = () => {
  const {id} = useParams<{id: string}>();
  return <Navigate to={`/trust-accounts/${id}${getSharePanelSearch('people')}`} replace />;
};
